import {GroupCriticalIllnessNY} from 'ApplicationEntry/models/ProductsRiders/CriticalIllnessNY/GroupCriticalIllnessNY';
import {NewYorkCriticalIllnessNY} from 'ApplicationEntry/models/ProductsRiders/CriticalIllnessNY/NewYorkCriticalIllnessNY';
import {OrdinaryCriticalIllnessNY} from 'ApplicationEntry/models/ProductsRiders/CriticalIllnessNY/OrdinaryCriticalIllnessNY';

export type CriticalIllnessNY = OrdinaryCriticalIllnessNY | GroupCriticalIllnessNY | NewYorkCriticalIllnessNY;

type ExhaustiveCriticalIllnessNYOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdinaryCriticalIllnessNY) => TReturn;
  Group: (group: GroupCriticalIllnessNY) => TReturn;
  NewYork: (newYork: NewYorkCriticalIllnessNY) => TReturn;
};

type PartialCriticalIllnessNYOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdinaryCriticalIllnessNY) => TReturn;
  Group?: (group: GroupCriticalIllnessNY) => TReturn;
  NewYork?: (newYork: NewYorkCriticalIllnessNY) => TReturn;
  _: (app: CriticalIllnessNY) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: CriticalIllnessNYByTypeOptions<TReturn>
): options is ExhaustiveCriticalIllnessNYOptionsByType<TReturn> =>
  !!options.Ordinary || (!!options.Group && !!options.NewYork);

type CriticalIllnessNYByTypeOptions<TReturn> =
  | PartialCriticalIllnessNYOptionsByType<TReturn>
  | ExhaustiveCriticalIllnessNYOptionsByType<TReturn>;

export const matchCriticalIllnessNYByType = <TReturn>(options: CriticalIllnessNYByTypeOptions<TReturn>) => (
  app: CriticalIllnessNY
): TReturn => {
  switch (app.key) {
    case 'InvalidOrdinaryCriticalIllnessNY':
    case 'ValidOrdinaryCriticalIllnessNY':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupCriticalIllnessNY':
    case 'ValidGroupCriticalIllnessNY':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkCriticalIllnessNY':
    case 'ValidNewYorkCriticalIllnessNY':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidCriticalIllnessNY = (criticalIllnessNY: CriticalIllnessNY) =>
  criticalIllnessNY.key === 'ValidOrdinaryCriticalIllnessNY' ||
  criticalIllnessNY.key === 'ValidGroupCriticalIllnessNY' ||
  criticalIllnessNY.key === 'ValidNewYorkCriticalIllnessNY';
